import styled from 'styled-components';

export const PageStyled = styled.div`
  background: ${props => props.theme.colors.paper};
  color: ${props => props.theme.colors.ink};
  font-family: ${props => props.theme.font};
  font-size: 16px;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  min-height: 100vh;

  * { box-sizing: border-box; }
  img, svg { display: block; max-width: 100%; }
  a { color: inherit; }
  button { font: inherit; }
  h1, h2, h3 { font-weight: 800; margin: 0; }
  h2 { font-size: clamp(1.35rem, 2.2vw, 1.7rem); color: ${props => props.theme.colors.ink}; }
  section { padding-block: 2.2rem; }
`;

export const Wrap = styled.div`
  max-width: ${props => props.theme.wrap};
  margin: 0 auto;
  padding-inline: ${props => props.theme.gutter};
`;

export const Card = styled.div`
  background: ${props => props.theme.colors.paperCard};
  border: 1px solid ${props => props.theme.colors.line};
  border-radius: ${props => props.theme.radius};
  box-shadow: ${props => props.theme.shadow};
`;

export const Eyebrow = styled.span`
  font-weight: 700;
  font-size: .74rem;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: ${props => props.theme.colors.inkFaint};
`;

export const SectionHead = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: .3rem;
`;

const btnBase = `
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  font-weight: 700;
  font-size: .85rem;
  border-radius: 999px;
  padding: .6rem 1.1rem;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
`;

export const BtnBrand = styled.a`
  ${btnBase}
  background: ${props => props.theme.colors.brand};
  color: ${props => props.theme.colors.brandInkOn};
`;

export const BtnOutline = styled.a`
  ${btnBase}
  background: transparent;
  border-color: ${props => props.theme.colors.lineStrong};
  color: ${props => props.theme.colors.ink};
`;

// Icône SVG inline "lucide-style" (stroke courant), ex: <Ic viewBox="0 0 24 24"><path d="..."/></Ic>
export const Ic = styled.svg`
  width: 1em;
  height: 1em;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  vertical-align: -.14em;
  display: inline-block;
`;
